import { PartyFieldLabel } from "@/components/parties/PartyFormSection";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  PARTY_ENTITY_KIND_LABELS,
  PARTY_ENTITY_KIND_VALUES,
  partyEntityKindFieldLabel,
  type PartyEntityKind,
} from "@/lib/parties/entityKind";
import type { PartyRole } from "@/lib/parties/partyTypes";

type Props = {
  role: PartyRole;
  value: PartyEntityKind;
  onChange: (value: PartyEntityKind) => void;
  disabled?: boolean;
};

export function PartyEntityKindField({ role, value, onChange, disabled }: Props) {
  return (
    <div className="space-y-2">
      <PartyFieldLabel>{partyEntityKindFieldLabel(role)}</PartyFieldLabel>
      <Select value={value} onValueChange={(next) => onChange(next as PartyEntityKind)} disabled={disabled}>
        <SelectTrigger className="glass-input h-10">
          <SelectValue placeholder="Select type" />
        </SelectTrigger>
        <SelectContent>
          {PARTY_ENTITY_KIND_VALUES.map((kind) => (
            <SelectItem key={kind} value={kind}>
              {PARTY_ENTITY_KIND_LABELS[kind]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
